import React, { useEffect, useState } from 'react'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import CurrencyInput from '../../components/Inputs/CurrencyInput'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import { TextArea } from '../../components/Inputs/TextArea'
import Switch from '../../components/Inputs/Switch'
import InputNumber from '../../components/Inputs/InputNumber'
import { useForm } from 'react-hook-form'
import { ISuscription } from './Suscriptions'
import SelectOfCategories from '../../components/Inputs/SelectOfCategories'
import Datepicker from '../../components/Inputs/Datepicker'
import RawAutoComplete from '../../components/Inputs/RawAutoComplete'
import { DateTime } from 'luxon'
import useSnackBars from '../../hooks/SnackbarConsumerHook'

const AddSuscriberForm: React.FC<any> = ({ onCancel, onSubmit, selectedSuscription, loadingSubscriber }) => {
  const [selectedClient, setSelectedClient] = useState<any | null>(null)

  const { addAlert } = useSnackBars()

  const form = useForm({
    defaultValues: {
        startDate: '',
        // endDate: '',
        client: null,
    },
  })

  const [defaultDate, setDefaultDate] = useState<string>(
    DateTime.local().setLocale('es').toFormat('d/M/yyyy')
  )

  const onSubmitForm = (values): void => {
    if (!selectedClient) {
      addAlert({message: 'El cliente es requerido', status: 'error'})
      return
    }
    onSubmit({...values, client: selectedClient, duration: 1})
  }

  useEffect(() => {
    if (selectedSuscription) {
        if (selectedSuscription?.frequency === 'monthly') { 
          const today = DateTime.local().setLocale('es');
          const nextMonth = today.plus({ months: 1 });
          const formattedDate = nextMonth.toFormat('d/M/yyyy');
          console.log('formattedDate', formattedDate)
          setDefaultDate(formattedDate);
        }
        if (selectedSuscription?.frequency === 'weekly') {
          const today = DateTime.local().setLocale('es');
          const nextWeek = today.plus({ weeks: 1 });
          const formattedDate = nextWeek.toFormat('d/M/yyyy');
          console.log('formattedDate', formattedDate)
          setDefaultDate(formattedDate);
        }
        if (selectedSuscription?.frequency === 'yearly') {
          const today = DateTime.local().setLocale('es');
          const nextYear = today.plus({ years: 1 });
          const formattedDate = nextYear.toFormat('d/M/yyyy');
          console.log('formattedDate', formattedDate)   
          setDefaultDate(formattedDate);
        }
    }
  }, [selectedSuscription])

  return (
    <>
      <Form
        form={form}
        classes={`gap-x-6 gap-y-4`}
        onSubmit={(values) => onSubmitForm(values)}
      >
        {/* Header */}
        <div
          className="col-span-12"
          style={{ fontWeight: 500, fontSize: '18px' }}
        >
          Añadir suscriptor
        </div>

        <FormItem
          name="startDate"
          classes="col-span-6"
          rules={{
            required: 'Debe especificar la fecha de creación del producto',
          }}
        >
          <Datepicker label="Fecha inicio de la suscripción" />
        </FormItem>

        <FormItem
          name="endDate"
          classes="col-span-6"
          rules={{
            required: 'Debe especificar la fecha de creación del producto',
          }}
          defaultValue={defaultDate}
        >
          <Datepicker label="Fecha fin de la suscripción" />
        </FormItem>

        <FormItem
          name="name"
          classes="col-span-12"
          rules={{ required: 'Es necesario una cuenta contable' }}
        >
          <RawAutoComplete
            label="Cliente"
            url={`thirdparty/client`}
            bodyGet={'clients'}
            outsideParams={['pageNumber=1', 'pageSize=10']}
            queryParam={'fastSearch'}
            selectedValue={selectedClient}
            setSelectedValue={(value) => {
              setSelectedClient(value)
            }}
          />
        </FormItem>

        <div
          style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
          className="col-span-12 mt-3"
        ></div>

        {/* Action Buttons */}
        <div className="col-span-12 h-full flex flex-row mt-4">
          <div className="w-1/2 mr-5 pl-1">
            <Button type="outline" classes="w-full" onClick={onCancel} disabled={loadingSubscriber}>
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button type="primary" classes="w-full" htmlType="submit" disabled={loadingSubscriber} loading={loadingSubscriber}>
              Guardar
            </Button>
          </div>
        </div>
      </Form>
    </>
  )
}

export default AddSuscriberForm
